<app-leveltwo [pageName]="'Disabled'">
    <div heading="General Info" class="General">
      <h3>{{'Disabled.SearchTitle'|translate}}</h3>
      <p>{{'Disabled.SearchDescription'|translate}}</p>

      <h4>{{'Disabled.TransferofProp'|translate}}</h4>
      <p><a routerLink="/homeowners/proposition-19">{{'Disabled.Propostion19'|translate}}</a> {{'Disabled.Allowspersons'|translate}}</p>
      <p [innerHTML]="'Disabled.Theeffective'|translate"></p>
      <p [innerHTML]="'Disabled.Note'|translate"></p>
      <!--
      <button type="button" class="btn btn-primary" routerLink="/homeowners/proposition-19">{{'Disabled.ClickhereProp19'|translate}}</button>
      <br><br>
      <p>{{'Disabled.Ifyouare'|translate}}</p>
      <button type="button" class="btn btn-primary" routerLink="/exemptions/disabled-veterans">{{'Disabled.ClickhereProp19'|translate}}</button>
      <br><br>
      -->
      <p [innerHTML]="'Disabled.Formorev2'|translate"></p>
      <!-- <p>{{'Disabled.TheAssessor'|translate}}</p>
      Major Exemptions<br>
      Phone: <b>(213) 974-3399</b><br>
      Email: <a href="mailto:exempt@assessor.lacounty.gov">exempt@asessor.lacounty.gov</a><br><br> -->
      <!--<p>{{'Disabled.Email'|translate}} | <a href="mailto:exempt@assessor.lacounty.gov">exempt@asessor.lacounty.gov</a></p>
-->
      <h4>{{'Disabled.Disabledpersons'|translate}}</h4>
      <p [innerHTML]="'Disabled.Qualifying'|translate"></p>
      <p [innerHTML]="'Disabled.Pleasesee'|translate"></p>
      <p>{{'Disabled.Inorder'|translate}}</p>
      <p>{{'Disabled.Theconstruction'|translate}}</p>

    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
